var map = {
	"./Animals-low.jpg": "9262",
	"./Animals.jpg": "26f0",
	"./Books-low.jpg": "f53b",
	"./Books.jpg": "987d",
	"./Drinks-low.jpg": "b53c",
	"./Drinks.jpg": "7f98",
	"./Education-low.jpg": "43a3",
	"./Education.jpg": "a1ca",
	"./Entertainment-low.jpg": "758d",
	"./Entertainment.jpg": "a353",
	"./Fashion-low.jpg": "5829",
	"./Fashion.jpg": "8ec4",
	"./Food-low.jpg": "55a0",
	"./Food.jpg": "4b03",
	"./Games-low.jpg": "25d6",
	"./Games.jpg": "011b",
	"./Health&Fitness-low.jpg": "c6ff",
	"./Health&Fitness.jpg": "c61c",
	"./Lifestyle-low.jpg": "08e5",
	"./Lifestyle.jpg": "b0f9",
	"./Miscellaneous-low.jpg": "2168",
	"./Miscellaneous.jpg": "0e55",
	"./Movies-low.jpg": "373e",
	"./Movies.jpg": "f19f",
	"./Music-low.jpg": "356b",
	"./Music.jpg": "30b5",
	"./Occupation-low.jpg": "4b47",
	"./Occupation.jpg": "78d4",
	"./People-low.jpg": "bfe3",
	"./People.jpg": "01ff",
	"./Science-low.jpg": "45c1",
	"./Science.jpg": "c373",
	"./Sports-low.jpg": "a460",
	"./Sports.jpg": "4bbe",
	"./Television-low.jpg": "ebc3",
	"./Television.jpg": "4580",
	"./background.jpg": "1100",
	"./emptyimage.jpg": "f494",
	"./nophoto.jpg": "da33"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "710a";